module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    class: _vm.color,
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-cen', {
    attrs: {
      "title": "Actividad"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Actividad',
      "videoEmbed": "ADMINISTRACIONDINERO07_01ActividadPresentacio.mp4"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "animated fadeInUp dura_1",
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm8": ""
    }
  }, [_c('p', [_vm._v("\n        En la siguiente actividad, usted puede ayudar a Juliana a tomar las decisiones \n        correctas para que pueda alcanzar su "), _c('strong', [_vm._v("meta")]), _vm._v(". "), _c('br'), _vm._v("\n        Para conseguirlo debe hacer clic en los botones, tomar las decisiones más acertadas y avanzar en la historia."), _c('br'), _c('br'), _vm._v("\n        Solo al finalizar podrá comprobar si logró acercarse a la meta.\n\n      ")])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated bounceIn dura_2",
    attrs: {
      "xs12": "",
      "text-xs-center": ""
    }
  }, [_c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.linksPath + (_vm.currentPage + 1),
      "aria-label": "Iniciar actividad"
    }
  }, [_c('ui-button', {
    attrs: {
      "content": 'Iniciar actividad',
      "botSize": 250,
      "aria": 'Iniciar actividad'
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogOne = true
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54133d22","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-07.vue
// module id = 977
// module chunks = 1